import { render, staticRenderFns } from "./student-data.vue?vue&type=template&id=275903a0&scoped=true"
import script from "./student-data.vue?vue&type=script&lang=js"
export * from "./student-data.vue?vue&type=script&lang=js"
import style0 from "./student-data.vue?vue&type=style&index=0&id=275903a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275903a0",
  null
  
)

export default component.exports